import React, {
  lazy,
} from 'react';
import {
  RouteObject,
} from 'react-router-dom';
import LazyLoadComponent from 'core/components/LazyLoadComponent';

const appointmentRoutes: RouteObject[] = [{
  path: '/appointments/',
  element: (
    <LazyLoadComponent Component={lazy(() => import('./pages/List'))} />
  ),
}];

export default appointmentRoutes;
